<mat-card>
    <img *ngIf="coverImage"
         mat-card-image
         class="cover-image"
         [src]="coverImage" />
    <mat-card-title *ngIf="title || moreMenus.length > 0 || shortcutMenus.length > 0"
                    class="header">
        <div>
            <span *ngIf="title">{{ title | translate }}</span>
            <span *ngIf="titleSwitcher.length > 0">
                <button mat-icon-button [matMenuTriggerFor]="titleSwitcherMenu">
                    <mat-icon>expand_more</mat-icon>
                </button>
            </span>
        </div>
        <div>
            <button *ngFor="let shortcut of shortcutMenus"
                    mat-icon-button
                    class="shortcut-menu"
                    [matTooltip]="shortcut.title | translate"
                    (click)="onMenuClicked(shortcut)">
                <mat-icon>{{ shortcut.icon }}</mat-icon>
            </button>
            <button *ngIf="moreMenus.length > 0"
                    mat-icon-button
                    [matMenuTriggerFor]="moreMenu">
                <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #moreMenu="matMenu"
                      xPosition="before">
                <button *ngFor="let menu of moreMenus"
                        mat-menu-item
                        (click)="onMenuClicked(menu)">
                    <mat-icon *ngIf="menu.icon">{{ menu.icon }}</mat-icon>{{ menu.title | translate }}
                </button>
            </mat-menu>
        </div>

        <mat-menu #titleSwitcherMenu="matMenu">
            <button *ngFor="let item of titleSwitcher" mat-menu-item (click)="onMenuClicked(item)">{{ item.title }}</button>
        </mat-menu>

    </mat-card-title>
    <mat-card-content>
        <ng-content></ng-content>
    </mat-card-content>
    <div *ngIf="mainActions.length > 0"
         class="main-actions"
         [class.main-actions-top]="mainActionsPosition == 'top'"
         [class.main-actions-bottom]="mainActionsPosition == 'bottom'">
        <button *ngFor="let action of mainActions"
                mat-fab
                color="accent"
                [disabled]="disableMainActionsWhenLoading && isLoading"
                [matTooltip]="action.title | translate"
                [matTooltipPosition]="mainActionsPosition == 'bottom' ? 'above' : 'below'"
                (click)="onMenuClicked(action)">
            <mat-icon>{{ action.icon }}</mat-icon>
        </button>
    </div>
    <mat-progress-bar *ngIf="isLoading"
                      mode="indeterminate"
                      color="accent"
                      class="loader"
                      [class.loader-top]="loaderPosition == 'top'"
                      [class.loader-bottom]="loaderPosition == 'bottom'"></mat-progress-bar>
</mat-card>
